var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ico",attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":_vm.stroke,"stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},_vm._l((_vm.paths),function(d,i){return _c('path',{key:i,attrs:{"d":d}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }